import React from "react";
import GridContainer from "../../components/Grid/GridContainer";
import { makeStyles } from "@mui/styles";
import styles from "../../assets/jss/material-kit-react/views/componentsSections/typographyStyle.js";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(styles);

export default function About() {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return (
    <div className={classes.sections}>
      <div className={classes.container}>
          <div id="typography">
          <div className={classes.title}>
            <h1>{t('About')}</h1>
          </div>

          {/* SEO Content for About Page */}
          <GridContainer>
            <div className={classes.typo}>
              <div className="seo-content">
                <h2>{t('aboutPage.seoTitle')}</h2>
                <p>{t('aboutPage.seoP1')}</p>
                <p>{t('aboutPage.seoP2Intro')}<a href="/" className="seo-link">{t('aboutPage.seoP2Link1')}</a>{t('aboutPage.seoP2Mid')}<a href="/" className="seo-link">{t('aboutPage.seoP2Link2')}</a>{t('aboutPage.seoP2Rest')}</p>
                <ul>
                  <li><strong>{t('aboutPage.li1Label')}</strong>{t('aboutPage.li1Rest')}</li>
                  <li><strong>{t('aboutPage.li2Label')}</strong>{t('aboutPage.li2Rest')}</li>
                  <li><strong>{t('aboutPage.li3Label')}</strong> <a href="/map" className="seo-link">{t('aboutPage.li3Link')}</a>{t('aboutPage.li3Rest')}</li>
                  <li><strong>{t('aboutPage.li4Label')}</strong> <a href="/compare" className="seo-link">{t('aboutPage.li4Link')}</a>{t('aboutPage.li4Rest')}</li>
                  <li><strong>{t('aboutPage.li5Label')}</strong>{t('aboutPage.li5Rest')}</li>
                </ul>

                {/* Additional Internal Links for SEO */}
                <p>{t('aboutPage.catalogIntro')}<a href="/catalog" className="seo-link">{t('aboutPage.catalogLink')}</a>{t('aboutPage.catalogMid')}<a href="/correlation" className="seo-link">{t('aboutPage.correlationLink')}</a>{t('aboutPage.correlationRest')}</p>
              </div>
            </div>
          </GridContainer>

          <GridContainer>
            <div className={classes.typo}>
              <div className={classes.note}>{t('Author')}</div>
              <p>Anton Nalyvaiko</p>
            </div>
          </GridContainer>

          <GridContainer>
            <div className={classes.typo}>
              <div className={classes.note}>{t('aboutPage.descNote')}</div>
              <div>{t('aboutPage.serviceDesc')}<br/>
                  {t('aboutPage.blogPrefix')}<a href="https://antonnalivayko1.medium.com/lists" target="blank">{t('aboutPage.blogLink')}</a>{t('aboutPage.blogSuffix')}<br/>
                  {t('aboutPage.introArticlePrefix')}<a href="https://antonnalivayko1.medium.com/world-economic-book-6613546e106b" target="blank">{t('aboutPage.articleLink')}</a>{t('aboutPage.articleSuffix')}<br/>
                  {t('aboutPage.euArticlePrefix')}<a href="https://antonnalivayko1.medium.com/economic-data-for-european-union-81631e1b78dd" target="blank">{t('aboutPage.articleLink')}</a>{t('aboutPage.euArticleSuffix')}<br/>
                  {t('aboutPage.usaArticlePrefix')}<a href="https://antonnalivayko1.medium.com/the-usa-and-canada-economic-data-bf912ff8abfb" target="blank">{t('aboutPage.articleLink')}</a>{t('aboutPage.usaArticleSuffix')}<br/><br/>

                  <p>{t('aboutPage.contact')}</p>
              </div>
            </div>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}